import { ReadyIcon, WarningIcon } from 'components/shared/PriceNext';
import { FormattedMessage } from 'react-intl';

const ReadyStatus = ({ hasBackendMessage }: { hasBackendMessage: boolean }) => (
  <div className="d-flex align-items-center gap-2 h-100 px-3 flex-grow-1">
    <span className="quote-ico">
      <ReadyIcon />
    </span>
    <span className="flex-grow-1">
      <FormattedMessage id="secondary-market-batch-grid.operation.status.ready" />
    </span>
    {hasBackendMessage && WarningIcon}
  </div>
);

export default ReadyStatus;
